import { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useRachelAttachmentsContext } from '../../contexts/RachelAttachments.context';
import { useRachelPresentation } from '../../hooks/useRachelPresentation';
import { CONTEXT_CHIP_ROW_HEIGHT } from '../RachelInput/rachelInput.styles';
import { useRachelContextChip } from '../RachelInput/useRachelContextChip';

export const useRachelChatLayout = () => {
  const { addFiles } = useRachelAttachmentsContext();
  const presentation = useRachelPresentation();
  const contextChip = useRachelContextChip();
  const [isConversationBottomVisible, setIsConversationBottomVisible] = useState(true);

  const { getRootProps, isDragActive } = useDropzone({
    noClick: true,
    noKeyboard: true,
    onDrop: (accepted: File[]) => addFiles(accepted),
  });

  return {
    getRootProps,
    isDragActive,
    presentation,
    contextChipOffset: presentation.mode === 'docked' && contextChip ? CONTEXT_CHIP_ROW_HEIGHT : 0,
    isConversationBottomVisible,
    setIsConversationBottomVisible,
  };
};
